/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GetAWSStackDetailsResponse {
  /**
  * The region to restore
  */
  'region': string;
  /**
  * The Id of the cloudformation stack
  */
  'stackId': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "region",
      "baseName": "region",
      "type": "string",
      "format": ""
    },
    {
      "name": "stackId",
      "baseName": "stackId",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetAWSStackDetailsResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

